// extracted by mini-css-extract-plugin
module.exports = {"select":"_21GV-D_3VPBLjy5m21iPoH"};